module.exports = __webpack_public_path__ + "img/icon7.ad9c4e6e.png";